(function () {
  var root = document.querySelector('.snw');
  if (!root) return;
  var cfg = {
    mode: root.getAttribute('data-mode') || 'preview',
    mcUrl: root.getAttribute('data-mc-url') || '',
    mcTag: root.getAttribute('data-mc-tag') || '',
    redirect: root.getAttribute('data-redirect') || '',
    sending: 'Sending...',
    errEmpty: 'Enter your email address so I can send the workshop.',
    errInvalid: 'That email address is missing something. Check it and try again.',
    errSend: 'The sign-up did not go through. Check your email address and try again.'
  };
  var utm = {};
  try {
    var qs = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) {
      var v = qs.get(k); if (v) utm[k] = v.slice(0, 120);
    });
  } catch (e) {}

  function showError(form, msg) {
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('.snw-form__err');
    input.setAttribute('aria-invalid', 'true');
    err.textContent = msg; err.hidden = false;
    input.focus();
  }
  function clearError(form) {
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('.snw-form__err');
    input.removeAttribute('aria-invalid');
    err.textContent = ''; err.hidden = true;
  }
  function done(form) {
    var pos = form.getAttribute('data-form');
    try {
      window.dataLayer = window.dataLayer || [];
      var ev = { event: 'snw_signup', snw_form: 'form-' + pos };
      for (var k in utm) ev[k] = utm[k];
      window.dataLayer.push(ev);
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('snw_signup', ev);
      }
    } catch (e) {}
    if (cfg.redirect) { window.location.href = cfg.redirect; return; }
    var thanks = root.getAttribute('data-thanks');
    root.querySelectorAll('.snw-form').forEach(function (f) {
      var box = document.createElement('p');
      box.className = 'snw-thanks';
      box.setAttribute('role', 'status');
      box.textContent = thanks;
      f.parentNode.replaceChild(box, f);
      if (f === form) { box.setAttribute('tabindex', '-1'); box.focus(); }
    });
  }
  function send(form, email, btn, label) {
    function fail() { btn.disabled = false; btn.textContent = label; showError(form, cfg.errSend); }
    if (cfg.mode !== 'mailchimp' || !cfg.mcUrl) { setTimeout(function () { done(form); }, 500); return; }
    var cb = 'snwcb' + Date.now();
    var params = ['EMAIL=' + encodeURIComponent(email), 'SNWFORM=form-' + form.getAttribute('data-form')];
    if (cfg.mcTag) params.push('tags=' + encodeURIComponent(cfg.mcTag));
    var map = { utm_source: 'UTMSOURCE', utm_medium: 'UTMMEDIUM', utm_campaign: 'UTMCAMP', utm_content: 'UTMCONTENT' };
    for (var k in utm) params.push(map[k] + '=' + encodeURIComponent(utm[k]));
    var hp = form.querySelector('.snw-hp input');
    if (hp && hp.value) { done(form); return; }
    var s = document.createElement('script');
    var timer = setTimeout(function () { cleanup(); fail(); }, 12000);
    function cleanup() { clearTimeout(timer); try { delete window[cb]; } catch (e) { window[cb] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); }
    window[cb] = function (res) {
      cleanup();
      var msg = (res && res.msg ? String(res.msg) : '').toLowerCase();
      if (res && (res.result === 'success' || msg.indexOf('already subscribed') > -1)) done(form);
      else fail();
    };
    s.onerror = function () { cleanup(); fail(); };
    s.src = cfg.mcUrl + (cfg.mcUrl.indexOf('?') > -1 ? '&' : '?') + params.join('&') + '&c=' + cb;
    document.body.appendChild(s);
  }
  root.querySelectorAll('.snw-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError(form);
      var input = form.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!email) { showError(form, cfg.errEmpty); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError(form, cfg.errInvalid); return; }
      var btn = form.querySelector('.snw-btn');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = cfg.sending;
      send(form, email, btn, label);
    });
  });
})();
